import ReportExportButton from 'components/reports/common/ReportExportButton'
import ReportPageTemplate from 'components/reports/common/ReportPageTemplate'
import TrustCheckReportFilter from 'components/reports/trustCheck/TrustCheckReportFilter'
import TrustCheckReportList from 'components/reports/trustCheck/TrustCheckReportList'
import TrustCheckReportSummary from 'components/reports/trustCheck/TrustCheckReportSummary'
import TrustCheckRunSelector from 'components/reports/trustCheck/TrustCheckRunSelector'
import { useAppSelector } from 'hooks/hooks'

const TrustCheckReportPage = () => {
    const { filters } = useAppSelector((state) => state.trustCheckReport)

    return (
        <ReportPageTemplate
            title="Trust check dry run"
            description="Read-only classification of every provider that was Premium in the selected period against the new trust & safety checks (IBAN, KvK / registry, repeat offender, high-risk category, website legal page). Nothing is enforced: the report shows what each check would have done, so the rules can be tuned before they gate sign-ups. Markets are shown side by side; the market filter below narrows both the summary and the list."
            exportButton={
                <ReportExportButton
                    exportEndpoint="office/trust-check-report/export"
                    filters={filters}
                />
            }
            filterComponent={
                <>
                    <TrustCheckRunSelector />
                    <TrustCheckReportFilter />
                </>
            }
            analyticsComponent={<TrustCheckReportSummary />}
            listComponent={<TrustCheckReportList />}
        />
    )
}

export default TrustCheckReportPage
